import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** *********************  START FETCH NPA DETAILS ******************** */
export const getNPAReportDetails = (fetchData: any) => {
	const data = {
		GetNPAReportDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchNPAReportDetails`;
	return makeApiCall(url, data);
};
/** *********************  END FETCH NPA DETAILS ******************** */
